import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';
import './index.css';
import App from './App';
import { EntitlementProvider } from './contexts/EntitlementContext';

// Only configure Amplify if credentials are present
if (awsExports.aws_user_pools_id) {
  Amplify.configure(awsExports);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <EntitlementProvider>
      <App />
    </EntitlementProvider>
  </React.StrictMode>
);
